/*! MSI 購物車客製：sync
 * 相依 msi-corp_cart-toolkit.js，必須排在它後面載入。
 * 由 scripts/build.mjs 從 cart-sync/src/ 產生，請勿直接修改本檔。
 */
(() => {
  var __create = Object.create;
  var __defProp = Object.defineProperty;
  var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
  var __getOwnPropNames = Object.getOwnPropertyNames;
  var __getProtoOf = Object.getPrototypeOf;
  var __hasOwnProp = Object.prototype.hasOwnProperty;
  var __commonJS = (cb, mod) => function __require() {
    try {
      return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
    } catch (e) {
      throw mod = 0, e;
    }
  };
  var __copyProps = (to, from, except, desc) => {
    if (from && typeof from === "object" || typeof from === "function") {
      for (let key of __getOwnPropNames(from))
        if (!__hasOwnProp.call(to, key) && key !== except)
          __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
    }
    return to;
  };
  var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
    // If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
    mod
  ));

  // msi-cart-toolkit-global:config
  var require_config = __commonJS({
    "msi-cart-toolkit-global:config"(exports, module) {
      if (!(window.MSI && window.MSI.cart)) {
        throw new Error("[MSI Cart] 找不到 window.MSI.cart，請確認 msi-corp_cart-toolkit.js 已在本檔之前載入");
      }
      module.exports = window.MSI.cart.config;
    }
  });

  // msi-cart-toolkit-global:http
  var require_http = __commonJS({
    "msi-cart-toolkit-global:http"(exports, module) {
      if (!(window.MSI && window.MSI.cart)) {
        throw new Error("[MSI Cart] 找不到 window.MSI.cart，請確認 msi-corp_cart-toolkit.js 已在本檔之前載入");
      }
      module.exports = window.MSI.cart.http;
    }
  });

  // msi-cart-toolkit-global:logger
  var require_logger = __commonJS({
    "msi-cart-toolkit-global:logger"(exports, module) {
      if (!(window.MSI && window.MSI.cart)) {
        throw new Error("[MSI Cart] 找不到 window.MSI.cart，請確認 msi-corp_cart-toolkit.js 已在本檔之前載入");
      }
      module.exports = window.MSI.cart.logger;
    }
  });

  // msi-cart-toolkit-global:reference
  var require_reference = __commonJS({
    "msi-cart-toolkit-global:reference"(exports, module) {
      if (!(window.MSI && window.MSI.cart)) {
        throw new Error("[MSI Cart] 找不到 window.MSI.cart，請確認 msi-corp_cart-toolkit.js 已在本檔之前載入");
      }
      module.exports = window.MSI.cart.reference;
    }
  });

  // msi-cart-toolkit-global:shopify
  var require_shopify = __commonJS({
    "msi-cart-toolkit-global:shopify"(exports, module) {
      if (!(window.MSI && window.MSI.cart)) {
        throw new Error("[MSI Cart] 找不到 window.MSI.cart，請確認 msi-corp_cart-toolkit.js 已在本檔之前載入");
      }
      module.exports = window.MSI.cart.shopify;
    }
  });

  // msi-cart-toolkit-global:storage
  var require_storage = __commonJS({
    "msi-cart-toolkit-global:storage"(exports, module) {
      if (!(window.MSI && window.MSI.cart)) {
        throw new Error("[MSI Cart] 找不到 window.MSI.cart，請確認 msi-corp_cart-toolkit.js 已在本檔之前載入");
      }
      module.exports = window.MSI.cart.storage;
    }
  });

  // msi-cart-toolkit-global:transport
  var require_transport = __commonJS({
    "msi-cart-toolkit-global:transport"(exports, module) {
      if (!(window.MSI && window.MSI.cart)) {
        throw new Error("[MSI Cart] 找不到 window.MSI.cart，請確認 msi-corp_cart-toolkit.js 已在本檔之前載入");
      }
      module.exports = window.MSI.cart.transport;
    }
  });

  // msi-cart-toolkit-global:lines
  var require_lines = __commonJS({
    "msi-cart-toolkit-global:lines"(exports, module) {
      if (!(window.MSI && window.MSI.cart)) {
        throw new Error("[MSI Cart] 找不到 window.MSI.cart，請確認 msi-corp_cart-toolkit.js 已在本檔之前載入");
      }
      module.exports = window.MSI.cart.lines;
    }
  });

  // cart-sync/src/integrations/sync/index.js
  var import_config = __toESM(require_config(), 1);
  var import_http = __toESM(require_http(), 1);
  var import_logger = __toESM(require_logger(), 1);
  var import_reference = __toESM(require_reference(), 1);
  var import_shopify = __toESM(require_shopify(), 1);
  var import_storage2 = __toESM(require_storage(), 1);
  var import_transport = __toESM(require_transport(), 1);

  // cart-sync/src/integrations/sync/engine.js
  var import_lines = __toESM(require_lines(), 1);
  var import_storage = __toESM(require_storage(), 1);
  var SYNC_DEBOUNCE_MS = 250;
  var SYNCED_HASH_KEY = "msiCartSyncedHash";
  function createCartSyncEngine({
    logger: logger2,
    cartReference,
    shopifyCart,
    transport,
    reloadGuard,
    getSdk = () => null,
    prepareTransport = () => Promise.resolve(),
    debounceMs = SYNC_DEBOUNCE_MS
  }) {
    let cartId = null;
    let lastSyncedLines = null;
    let syncTimer = null;
    let hasMissedMutation = false;
    let isBooted = false;
    function rememberSyncedLines(lines) {
      lastSyncedLines = lines;
      (0, import_storage.writeStoredValue)(
        "localStorage",
        SYNCED_HASH_KEY,
        (0, import_lines.hashFingerprint)((0, import_lines.linesFingerprint)(lines))
      );
    }
    function discardStaleCart() {
      cartId = null;
      lastSyncedLines = null;
      cartReference.remove();
      const sdk = getSdk();
      if (sdk) sdk.clearCart();
      logger2.warn("遠端購物車不存在或已過期，已清除本機參照");
    }
    function pushToMsi(lines) {
      return transport.run("寫回", function(activeTransport) {
        return activeTransport.push(lines, cartId);
      }).then(function(payload) {
        cartId = cartReference.readCartId() || payload && payload.cart_id || cartId;
        rememberSyncedLines((0, import_lines.normalizeRemoteLines)(payload) || lines);
        logger2.log("已寫回 MSI", { count: lines.length });
        return payload;
      }).catch(function(error) {
        lastSyncedLines = null;
        logger2.fail("寫回 MSI 失敗", error.message);
        if (error.status === 404 && cartId) discardStaleCart();
        return null;
      });
    }
    function alignShopifyWith(targetLines, previousLines, canPushBack) {
      return shopifyCart.applyLines(targetLines, previousLines).then(function(result) {
        if (result.hasFailed) {
          lastSyncedLines = null;
          return result;
        }
        const hasRemoteGap = canPushBack && !(0, import_lines.areLinesEqual)(result.lines, targetLines);
        const hasLocalChanged = !(0, import_lines.areLinesEqual)(result.lines, previousLines);
        rememberSyncedLines(result.lines);
        if (hasRemoteGap) logger2.warn("Shopify 調整了購物車內容，正在回寫 MSI");
        const pushBack = hasRemoteGap ? pushToMsi(result.lines) : Promise.resolve(null);
        return pushBack.then(function() {
          if (!hasLocalChanged) return result;
          logger2.log("已用遠端內容覆寫 Shopify 購物車", { count: result.lines.length });
          document.dispatchEvent(new CustomEvent("msi:cart-synced", { bubbles: true }));
          reloadGuard.reloadOnce((0, import_lines.linesFingerprint)(result.lines));
          return result;
        });
      });
    }
    function pushAndReconcile(lines) {
      return pushToMsi(lines).then(function(payload) {
        const remoteLines = payload ? (0, import_lines.normalizeRemoteLines)(payload) : null;
        if (!remoteLines || (0, import_lines.areLinesEqual)(remoteLines, lines)) return null;
        logger2.warn("後端調整了購物車內容，正在同步回 Shopify");
        return alignShopifyWith(remoteLines, lines, false);
      });
    }
    function syncLocalToMsi() {
      return shopifyCart.readLines().then(function(lines) {
        if ((0, import_lines.areLinesEqual)(lines, lastSyncedLines)) return null;
        return pushAndReconcile(lines);
      });
    }
    function resolveBootDirection(localLines, remoteLines) {
      const localHash = (0, import_lines.hashFingerprint)((0, import_lines.linesFingerprint)(localLines));
      const remoteHash = (0, import_lines.hashFingerprint)((0, import_lines.linesFingerprint)(remoteLines));
      if (localHash === remoteHash) {
        rememberSyncedLines(localLines);
        return null;
      }
      const syncedHash = (0, import_storage.readStoredValue)("localStorage", SYNCED_HASH_KEY);
      const hasLocalChange = hasMissedMutation || syncedHash !== null && localHash !== syncedHash;
      const hasRemoteChange = syncedHash === null || remoteHash !== syncedHash;
      if (hasLocalChange && !hasRemoteChange) {
        logger2.log("僅本機有變更，以本機內容為準");
        return pushAndReconcile(localLines);
      }
      if (hasLocalChange) logger2.warn("本機與遠端皆有變更，以遠端內容為準");
      return alignShopifyWith(remoteLines, localLines, true);
    }
    function verifyRemoteLines(result, localLines) {
      if (result.isTrustworthy || localLines.length === 0) return Promise.resolve(result.lines);
      return transport.direct.sync(cartId).then(
        function(verified) {
          return verified.lines;
        },
        function(error) {
          logger2.warn("無法確認遠端是否為空車，改以本機內容為準", error.message);
          return null;
        }
      );
    }
    function scheduleSync() {
      if (!isBooted) {
        hasMissedMutation = true;
        return;
      }
      clearTimeout(syncTimer);
      syncTimer = setTimeout(function() {
        syncLocalToMsi().catch(function(error) {
          logger2.fail("同步失敗", error.message);
        });
      }, debounceMs);
    }
    return {
      /** SDK 降級時重讀 cookie：SDK 可能已建立購物車並寫好 cookie，避免重複建立。 */
      adoptExistingCartId() {
        cartId = cartReference.readCartId() || cartId;
      },
      scheduleSync,
      boot() {
        const localRead = shopifyCart.readLines().then(
          (lines) => ({ lines }),
          (error) => ({ error })
        );
        const remoteRead = Promise.resolve().then(prepareTransport).then(function() {
          cartId = cartReference.readCartId();
          if (!cartId) return null;
          return transport.run("初始同步", (activeTransport) => activeTransport.sync(cartId));
        }).then(
          (result) => ({ result }),
          (error) => ({ error })
        );
        return Promise.all([localRead, remoteRead]).then(function([local, remote]) {
          if (local.error) throw local.error;
          if (hasMissedMutation && !remote.error) {
            return shopifyCart.readLines().then((lines) => [{ lines }, remote]);
          }
          return [local, remote];
        }).then(function([local, remote]) {
          if (remote.error) {
            logger2.fail("初始同步失敗", remote.error.message);
            if (remote.error.status === 404) discardStaleCart();
            return null;
          }
          const localLines = local.lines;
          if (!cartId) {
            if (localLines.length === 0) return null;
            logger2.log("本機有商品但無遠端購物車，建立中");
            return pushAndReconcile(localLines);
          }
          return verifyRemoteLines(remote.result, localLines).then(function(remoteLines) {
            if (!remoteLines) return pushAndReconcile(localLines);
            return resolveBootDirection(localLines, remoteLines);
          }).catch(function(error) {
            logger2.fail("初始同步失敗", error.message);
            if (error.status === 404) discardStaleCart();
            return null;
          });
        });
      },
      /**
       * ⚠ 必須在 boot 的最外層 catch 之後呼叫。
       * boot 任何一步 reject 若讓 isBooted 停在 false，之後所有同步會永久停擺。
       */
      markBooted() {
        isBooted = true;
        if (!hasMissedMutation) return;
        hasMissedMutation = false;
        scheduleSync();
      }
    };
  }

  // cart-sync/src/integrations/sync/index.js
  var config = (0, import_config.readCartSyncConfig)();
  var logger = (0, import_logger.createCartLogger)({ debug: config.debug });
  var fetchTap = window.MSI && window.MSI.cartFetchTap;
  var loading = window.MSI && window.MSI.cartSyncLoading;
  if (!fetchTap) {
    logger.fail("找不到 fetch 樞紐，請確認 msi-corp_cart-sync.liquid 已在 <head> 內 render");
    if (loading) loading.finish();
  } else {
    start(fetchTap);
  }
  function start(tap) {
    const nativeFetch = tap.nativeFetch;
    const routeRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || "/";
    const cartReference = (0, import_reference.createCartReference)({ logger });
    const shopifyCart = (0, import_shopify.createShopifyCart)({ fetch: nativeFetch, routeRoot, logger });
    const reloadGuard = (0, import_storage2.createReloadGuard)({
      logger,
      onReload: () => {
        if (loading) loading.beforeReload();
      },
      canReload: () => !loading || !loading.isTimedOut()
    });
    const directTransport = (0, import_transport.createDirectTransport)({
      http: (0, import_http.createHttpClient)({ fetch: nativeFetch, timeoutMs: config.requestTimeoutMs }),
      endpoints: (0, import_transport.buildDirectEndpoints)(config),
      cartReference,
      logger
    });
    let sdk = null;
    const transport = (0, import_transport.createTransportRouter)({
      transportMode: config.transportMode,
      getSdk: () => sdk,
      directTransport,
      sdkApiDomain: config.sdkApiDomain,
      requestTimeoutMs: config.requestTimeoutMs,
      logger,
      onFallback: () => engine.adoptExistingCartId()
    });
    const engine = createCartSyncEngine({
      logger,
      cartReference,
      shopifyCart,
      transport,
      reloadGuard,
      getSdk: () => sdk,
      prepareTransport: () => (0, import_transport.loadCartSdk)(config).catch(function(error) {
        logger.warn("SDK 載入失敗，改用直連模式", error.message);
        return null;
      }).then(function(loadedSdk) {
        sdk = loadedSdk;
      })
    });
    tap.subscribe(() => engine.scheduleSync());
    engine.boot().catch(function(error) {
      logger.fail("初始化失敗", error.message);
    }).then(function() {
      engine.markBooted();
      if (loading) loading.finish();
    });
  }
})();
